export default __webpack_public_path__ + "static/media/Vashian Threads.738c7d93.jpg";